<template>
    <div @keyup.escape="onPressEscape()">
        <form @keydown.enter.prevent>
            <div class="search-input">
                <div class="control-group">
                    <div class="control" role="search">
                        <input
                            type="text"
                            :placeholder="Language.say(text_search_placeholder)"
                            v-focus="true"
                            v-model="search_input"
                            @keyup="onInputSearch($event)"
                        >

                        <ActionButton v-show="search_input"
                            @click="onInputClear()"
                            icon='fas fa-times'
                            class="clear"
                        />

                        <button type="submit">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup>
  import { ref, defineEmits, defineProps, defineExpose } from "vue";
  import ActionButton                                    from '@/vue/Elements/Buttons/ActionButton.vue';
  import Language                                        from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    initial_search_input : {
      default: '',
    },

    text_search_placeholder : {
      default: 'global.placeholders.search'
    }
  })

  const emit = defineEmits([
    'inputSearchSet', 'inputSearchReset', 'inputSearchClear', 'inputSearchEscape',
  ]);

  const search_input  = ref(props.initial_search_input);
  const input_cleared = ref(false);
  const last_input    = ref();

  const onInputClear = () => {
    inputCleared();
    resetInput();
  }

  const onPressEscape = () => {
    emit('inputSearchEscape');
  }

  const onInputSearch = ($event) => {
    if (last_input.value === search_input.value) {
      return;
    }

    setLastInput(search_input.value);

    if (!search_input.value) {
      inputCleared();
      return;
    }

    emit('inputSearchSet', search_input.value);
  }

  const inputCleared = () => {
    emit('inputSearchClear');
  }

  const resetInput = () => {
    search_input.value = null;
  }

  const setLastInput = (value) => {
    last_input.value = value;
  }

  defineExpose({
    resetInput:resetInput,
  })
</script>
